import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Permission } from 'magma/common/interfaces';
import { ProjectService } from 'services/projects.service';
import { TeamMembersService } from 'services/team-members.service';
import { TeamService } from 'services/team.service';
import { ProjectData } from 'shared/interfaces';
import { routeToTeam, getLastProject, removeLastProject } from 'shared/utils';

@Component({
  selector: 'delete-project-modal',
  templateUrl: './delete-project-modal.component.pug',
})
export class DeleteProjectModalComponent {
  @Input() data!: ProjectData;
  @Output() close = new EventEmitter();
  error = '';
  loading = false;
  constructor(
    private projectService: ProjectService,
    private teamService: TeamService,
    private router: Router,
    private teamMemberService: TeamMembersService,
  ) { }
  async submit() {
    try {
      this.loading = true;
      await this.projectService.deleteProject(this.data._id, this.data.team);
      const slug = this.teamService.getTeamSlug(this.data.team)!;
      if (getLastProject(slug) === this.data._id) {
        removeLastProject(slug);
      }

      await this.router.navigate(routeToTeam(slug));
      this.close.emit();
    } catch (e) {
      this.loading = false;
      this.error = e.message;
    }
  }
  onClose() {
    this.close.emit();
  }
  get canDeleteProject() {
    return this.teamMemberService.isPermissionFlagSet([Permission.CanDeleteProjects]);
  }
}
